export default {} as Record<string, string>;
